import { render, staticRenderFns } from "./NotificationSettingModal.vue?vue&type=template&id=407ba79f&"
import script from "./NotificationSettingModal.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports